import { UploadImageResponse, UploadImageRequest } from '@models/upload-service.model';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

/**
 * RTK Query API slice for uploading images to the backend upload endpoint.
 *
 * - Provides a mutation for uploading images, optionally linked to a recordId.
 * - Uses /api/upload as the base endpoint.
 */
export const uploadServiceApi = createApi({
  reducerPath: 'uploadServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api',
  }),
  endpoints: (builder) => ({
    /**
     * Mutation for uploading an image file to the backend.
     *
     * @param formData - FormData containing the file to upload
     * @param recordId - Optional record ID to associate the upload
     * @returns UploadImageResponse from the API
     */
    uploadImage: builder.mutation<UploadImageResponse, UploadImageRequest>({
      query: ({ formData, recordId }) => {
        const url = recordId ? `/upload?recordId=${recordId}` : '/upload';
        return {
          url,
          method: 'POST',
          body: formData,
        };
      },
    }),
  }),
});

/**
 * React hook for triggering the uploadImage mutation.
 *
 * @returns A tuple with the trigger function and mutation state
 */
export const { useUploadImageMutation } = uploadServiceApi;